export * from './_id/actions';

import { deleteCoreApiGatewayKeysByIdSlice } from './_id/delete';
import { getCoreApiGatewayKeysSlice } from './get';
import { patchCoreApiGatewayKeysByIdSlice } from './_id/patch';
import { postCoreApiGatewayKeysSlice } from './post';

export const { requestGetCoreApiGatewayKeys, resetGetCoreApiGatewayKeys } =
	getCoreApiGatewayKeysSlice.asyncActionCreators;

export const { requestPostCoreApiGatewayKeys, resetPostCoreApiGatewayKeys } =
	postCoreApiGatewayKeysSlice.asyncActionCreators;

export const { requestDeleteCoreApiGatewayKeysById, resetDeleteCoreApiGatewayKeysById } =
	deleteCoreApiGatewayKeysByIdSlice.asyncActionCreators;

export const { requestPatchCoreApiGatewayKeysById, resetPatchCoreApiGatewayKeysById } =
	patchCoreApiGatewayKeysByIdSlice.asyncActionCreators;
